import { get } from "svelte/store";
import AlertsStore from "./Alerts/Store";
import AppMenuTab from "./AppMenuTab";
import AppStore from "./AppStore";
import MaritimeMenuTab from "./MaritimeMenuTab";
import InfoCardStore from "./UI/InfoCard/Store";
import RangeRingStore from "./UI/MeasureTool/RangeRing/Store";
import MeasureStore from "./UI/MeasureTool/Store";
import VesselHistoryStore from "./UI/VesselHistory/Store";
import VesselsNearbyStore from "./UI/VesselsNearby/Store";
import WeatherStore from "./Weather/Store";

import moment from "moment";
import DownsampleRate from "./Enums/DownsampleRate";
import imoValidator from "./Helpers/Misc/imoValidator";
import VesselProperty from "./Models/Enums/VesselProperty";

import Feature from "./Branding/Feature";
import User from "./Branding/User";
import VesselIDType from "./Models/Enums/VesselIDType";

import AircraftHistoryStore from "./Aviation/AircraftHistoryStore";
import RoutePlottingStore from "./UI/MeasureTool/RoutePlottingStore";

const Router = {
	hasRan: false
};
Router.run = () => {
	if (Router.hasRan) {
		console.warn("Router has already ran.");
		return;
	}
	const urlParams = new URLSearchParams(location.search);
	const imo = urlParams.get("imo");
	if (urlParams.has("imo")) {
		if (!imoValidator(imo)) {
			console.warn("Invalid IMO parameter in URL:", imo);
		}
		else {
			if (!AlertsStore.vesselGroup.containsProperty(VesselProperty.IMO, imo)) {
				console.warn("IMO passed in URL not in current alert list:", imo);
			}
			else {
				const vessel = AlertsStore.vesselGroup.find({ imo: imo });
				if (vessel) {
					AlertsStore.vesselGroup.deselectAll();
					vessel.selected = true;
					vessel.focused = true;
				}
			}
		}
	}
	else if (urlParams.has("r")) {
		if (urlParams.get("r") === "vh" && urlParams.has("vh")) {
			// e.g. http://localhost:5555/?r=vh&vh=636020069,309333000&type=mmsi&from=2021-12-09&to=2021-12-17
			const imosOrMMSIsList = urlParams.get("vh").split(","); // imo/mmsi data csv
			const vesselIdType = urlParams.get("type"); // VesselIDType.IMO

			const from = new Date(urlParams.get("from"));
			const to = new Date(urlParams.get("to"));

			Router.actions.gotoVesselHistoryForListAndPeriod(vesselIdType, imosOrMMSIsList, from, to);
		}
	}
	Router.hasRan = true;
};

Router.actions = {};
Router.actions.gotoVesselHistory = (vessel) => {
	if (!vessel) {
		return;
	}
	AppStore.actions.setMenuVisible(true);

	const imo = vessel.imo;
	const mmsi = vessel.mmsi;
	let useMmsi = false;

	VesselHistoryStore.query.inputType.set(VesselIDType.IMO);
	VesselHistoryStore.query.vesselInputs.set(["" + imo]);
	if (("" + mmsi).length > 0 && User.hasFeature(Feature.VESSEL_HISTORY.SEARCH_BY_MMSI)) {
		useMmsi = true;
		VesselHistoryStore.query.inputType.set(VesselIDType.MMSI);
		VesselHistoryStore.query.vesselInputs.set(["" + mmsi]);
	}

	const useDate = new Date();
	const pastDate = useDate.getDate() - 7;
	useDate.setDate(pastDate);
	VesselHistoryStore.query.fromDatetime.set(useDate);
	VesselHistoryStore.query.toDatetime.set(new Date());

	AppStore.menu.tab.set(AppMenuTab.MARITIME);
	AppStore.menu.maritime.tab.set(MaritimeMenuTab.VESSEL_HISTORY);
	VesselHistoryStore.actions.setupLimitedInputs(
		((!useMmsi) ? ["" + imo] : []),
		((useMmsi) ? ["" + mmsi] : [])
	);

	setTimeout(() => {
		VesselHistoryStore.query.downsampling.set(DownsampleRate.NONE);
		const resetbtn = document.querySelector("#vessel-history-reset");
		if (resetbtn) {
			resetbtn.click(); // HACK. TODO: consider moving api request and data processing into VesselHistoryStore.actions.submit() action.
		}
		setTimeout(() => {
			document.querySelector("#vessel-history-submit").click(); // HACK. TODO: consider moving api request and data processing into VesselHistoryStore.actions.submit() action.
		}, 2);
	}, 2);
};
Router.actions.gotoVesselHistoryForVessels = (vesselObjs, beforeDays = 3, afterDays = 3) => {
	VesselHistoryStore.actions.resetQuery();
	VesselHistoryStore.actions.resetMeta();
	VesselHistoryStore.actions.resetResults();

	if (User.hasFeature(Feature.VESSEL_HISTORY.SEARCH_BY_MMSI)) {
		const mmsis = vesselObjs.map((v) => {
			return v.mmsi;
		});
		Router.actions.gotoVesselHistoryForList(VesselIDType.MMSI, mmsis, beforeDays, afterDays);
		return;
	}

	const imos = vesselObjs.map((v) => {
		return v.imo;
	});
	Router.actions.gotoVesselHistoryForList(VesselIDType.IMO, imos, beforeDays, afterDays);
};
Router.actions.gotoVesselHistoryForList = (vesselIdType, imoList = [], beforeDays = 3, afterDays = 3) => {
	const from = moment(get(VesselsNearbyStore.query.computed.fromDatetime));
	const to = moment(get(VesselsNearbyStore.query.computed.toDatetime));

	const dateStart = from.subtract(beforeDays, "days").toDate();
	const dateEnd = to.add(afterDays, "days").toDate();

	Router.actions.gotoVesselHistoryForListAndPeriod(vesselIdType, imoList, dateStart, dateEnd);
};
Router.actions.gotoVesselHistoryForListAndPeriod = (vesselIdType, imoList, dateStart, dateEnd) => {
	AppStore.actions.setMenuVisible(true);

	VesselHistoryStore.query.inputType.set(vesselIdType);
	VesselHistoryStore.query.vesselInputs.set(imoList);
	VesselHistoryStore.query.fromDatetime.set(dateStart);
	VesselHistoryStore.query.toDatetime.set(dateEnd);

	AppStore.menu.tab.set(AppMenuTab.MARITIME);
	AppStore.menu.maritime.tab.set(MaritimeMenuTab.VESSEL_HISTORY);
	VesselHistoryStore.actions.setupLimitedInputs(imoList.join(","), []);

	setTimeout(() => {
		VesselHistoryStore.query.downsampling.set(DownsampleRate.NONE);
		const btn = document.querySelector("#vessel-history-submit");
		if (btn) {
			btn.click(); // HACK. TODO: consider moving api request and data processing into VesselHistoryStore.actions.submit() action.
		}
	}, 1);
};

Router.actions.gotoAircraftHistory = (aircraft) => {
	return Router.actions.gotoAircraftHistoryForICAOAddresses([aircraft.icaoAddress]);
};
Router.actions.gotoAircraftHistoryForICAOAddresses = (icaoAddressList) => {
	const to = moment(new Date());
	const from = moment(new Date());

	const dateEnd = to.endOf("day").toDate();
	const dateStart = from.startOf("day").subtract(1, "days").toDate();
	return Router.actions.gotoAircraftHistoryForICAOAddressesAndPeriod(icaoAddressList, dateStart, dateEnd);
};
Router.actions.gotoAircraftHistoryForICAOAddressesAndPeriod = (icaoAddressList, dateStart, dateEnd) => {
	AppStore.actions.setMenuVisible(true);

	AircraftHistoryStore.query.inputString.set(icaoAddressList.join(","));
	AircraftHistoryStore.query.inputLength.set(icaoAddressList.length);
	AircraftHistoryStore.query.inputValid.set(true);
	AircraftHistoryStore.query.validInputs.set(icaoAddressList);
	AircraftHistoryStore.query.fromDatetime.set(dateStart);
	AircraftHistoryStore.query.toDatetime.set(dateEnd);

	AppStore.menu.tab.set(AppMenuTab.AVIATION);
	AppStore.menu.aviation.tab.set("History");

	setTimeout(() => {
		// AircraftHistoryStore.query.downsampling.set(DownsampleRate.NONE);
		const btn = document.querySelector("#aircraft-history-submit");
		if (btn) {
			btn.click(); // HACK. TODO: consider moving api request and data processing into AircraftHistoryStore.actions.submit() action.
		}
	}, 1);
};

Router.actions.gotoVesselsNearby = (vessel) => {
	if (!vessel) {
		return;
	}

	let currentDate = moment(Date.now());
	if (vessel.hasActiveSnapshot()) {
		currentDate = moment(vessel.snapshotTimestamp);
	}
	// const fromDate = new Date();
	// const toDate = new Date();
	// fromDate.setDate(currentDate.getDate() - 1);
	// toDate.setDate(currentDate.getDate() + 1);
	VesselsNearbyStore.query.raw.useVessel.set(vessel);
	VesselsNearbyStore.query.raw.baseDatetime.set(currentDate); // fromDate);
	VesselsNearbyStore.query.raw.timeWindowHrs.set(12);
	// VesselsNearbyStore.query.toDatetime.set(toDate);

	AppStore.actions.setMenuVisible(true);
	AppStore.menu.tab.set(AppMenuTab.MARITIME);
	AppStore.menu.maritime.tab.set(MaritimeMenuTab.VESSELS_NEARBY);
	setTimeout(() => {
		// TODO: click submit?
		// HACK. TODO: consider moving api request and data processing into VesselsNearbyStore.actions.submit() action.
		document.querySelector("#vessels-nearby-submit").click();
	}, 1);
};
Router.actions.gotoMeasure = (vessel) => {
	if (!vessel) {
		return;
	}

	// FILTHY HACK!
	// We want to reload the MeasureTool component (and RangeRingViews) with all the correct data.
	// If we don't do this, the textfields get stuck with old data and don't update.
	// It's weird, and I don't have time for it right now!
	// AppStore.menuTab.set(AppMenuTab.ALERTS); // FILTHY HACK.
	// AppStore.actions.setMenuVisible(true);

	const useSpeed = (vessel.speed > 0) ? vessel.speed : 10; // 10 knots default.

	const useLng = (vessel.hasActiveSnapshot()) ? vessel.snapshotLng : vessel.lng;
	const useLat = (vessel.hasActiveSnapshot()) ? vessel.snapshotLat : vessel.lat;

	const currentTimestamp = new Date(vessel.timestamp);
	const allFeaturePoints = AlertsStore.helpers.GetGeoJson.paths.all().points.features;
	let latestTimestamp = new Date(0);
	let countHistoric = 0;
	for (let i = 0; i < allFeaturePoints.length; i++) {
		if (allFeaturePoints[i].properties[vessel.map[VesselProperty.IMO]] === vessel.imo) {
			countHistoric++;
			if (new Date(allFeaturePoints[i].properties[vessel.map[VesselProperty.TIMESTAMP]]) >= latestTimestamp) {
				latestTimestamp = new Date(allFeaturePoints[i].properties[vessel.map[VesselProperty.TIMESTAMP]]);
			}
		}
	}
	let useTime = 60; // 60 minutes default
	if (countHistoric > 0) {
		// This code works, but is disabled. We always want to see a range ring when coming from the info card, so default to 1 hour.
		// let timeDiffInMillis = Math.abs(latestTimestamp - currentTimestamp)
		// let timeDiffMinutes = Math.round(timeDiffInMillis / 1000.0 / 60.0);
		// useTime = timeDiffMinutes;

		// Make it use the timeSinceUpdate value!
		const nowTimestamp = new Date();
		const timeDiffInMillis = Math.abs(nowTimestamp - currentTimestamp);
		const timeDiffMinutes = Math.round(timeDiffInMillis / 1000.0 / 60.0);
		useTime = timeDiffMinutes;
	}

	RoutePlottingStore.meta.visible.set(true);

	MeasureStore.actions.clearAllPoints();
	RangeRingStore.actions.clearAll();

	RangeRingStore.actions.add();
	RangeRingStore.actions.setTop(useLng, useLat, useTime, useSpeed);
	MeasureStore.actions.addPointAt(useLng, useLat);

	// MeasureStore.helpers.onLineUpdated();
	MeasureStore.actions.update();
	// MeasureStore.helpers.rebuildGeoJSON();

	InfoCardStore.meta.lastUpdated.set(Date.now()); // Makes the map zoom to the vessel again.
	InfoCardStore.actions.close();
};

Router.actions.gotoEnvironment = (vessel) => {
	if (!vessel) {
		return;
	}

	const useLng = (vessel.hasActiveSnapshot()) ? vessel.snapshotLng : vessel.lng;
	const useLat = (vessel.hasActiveSnapshot()) ? vessel.snapshotLat : vessel.lat;

	WeatherStore.query.useVessel.set(vessel);
	WeatherStore.query.lngLat.set({ lng: useLng, lat: useLat });

	AppStore.menu.tab.set(AppMenuTab.ENVIRONMENT);
	AppStore.menu.visible.set(true);

	// WeatherStore.actions.submit();
};

export default Router;
